// import GuestService from '../../../services/service'
// import { LoadingActionCreators } from '../loading/action-creators'
import { baseURL } from '../../../http'
import { fetchWithTimeout, toQueryParams } from '../../../utils/query'
import { GuestPaymentActionCreators } from '../guestPayment/action-creators'
import { LoadingActionCreators } from '../loading/action-creators'
import { MsgToUserActionCreators } from '../msgToUser/action-creators'
import { MessageType } from '../msgToUser/types'

export const GuestActionCreators = {
  doGuestPay:
    (
      serviceId,
      amount,
      fields,
      payAllDebt,
      subName,
      subVal,
      selectedGroupId,
      returnUrl,
      cardPanId,
      tokenType,
    ) =>
    async dispatch => {
      console.log(`fields:`, fields)

      dispatch(LoadingActionCreators.loadingPaymentState(true))
      try {
        const response = await fetchWithTimeout(
          baseURL + '/guest/do_pay_with_group_id',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'Payment-Origin': 'frames',
            },
            body: toQueryParams({
              serviceId: serviceId,
              amount: amount,
              fields: fields,
              payAllDebt: payAllDebt,
              subName: subName,
              subVal: subVal,
              selectedGroupId: selectedGroupId,
              returnUrl: returnUrl,
              cardPanId: cardPanId,
              tokenType,
            }),
          },
        )
        if (response.status === 200) {
          const json = await response.json()
          if (json.resultCodes === 'OK') {
            dispatch(
              GuestPaymentActionCreators.saveUrlOrder(
                json.formUrl,
                json.historyId,
                json.orderId,
              ),
            )
            return json.formUrl
          } else {
            // dispatch(MsgToUserState(MessageType.SomeError));
          }
        } else {
          // dispatch(MsgToUserState(MessageType.SomeError));
        }
      } catch (e) {
        console.warn('error', e)
        dispatch(MsgToUserActionCreators.msgToUserState(MessageType.CatchError))
      } finally {
        dispatch(LoadingActionCreators.loadingPaymentState(false))
      }
    },
}
